import React, {Fragment} from 'react';
import {Modal} from "../common/Modal";
import {useModelFormEngine} from "../common/hooks/useModelFormEngine";
import {ApiUtility} from "../common/ApiUtility";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {SelectUtility} from "../common/SelectUtility";
import {Constants} from "../common/Constants";
import {PillButton} from "../common/PillButton";
import {DateUtility} from "../common/DateUtility";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import {StringUtility} from "../common/StringUtility";
import "react-datepicker/dist/react-datepicker.css";
import {InvoiceDataUtility} from "../common/InvoiceDataUtility";
import {CustomerDataUtility} from "../common/CustomerDataUtility";
import {CreateStripeCustomer} from "../customers/CreateStripeCustomer";
import {CreateQboCustomer} from "../customers/CreateQboCustomer";
import {InvoiceLineWithServicesFormRow} from "../invoices/InvoiceLineWithServicesFormRow";
import _ from "lodash";

const getInvoiceLineFieldId = InvoiceDataUtility.getInvoiceLineFieldId

export let SubscriptionForm = function (props) {
    const subscription = _.clone(props.fpInvoiceAsSubscriptionData || props.subscription) || {};
    const fpInvoice = _.clone(props.fpInvoice) || {};

    const emptyInvoiceLine = {
        invoice_line_type_id: Constants.qboInvoiceLineTypes.fpService,
        fp_service_id: null,
        fp_service_type_id: null,
        name: '',
        amount: '0',
    };

    let proposedCustomer = CustomerDataUtility.proposedCustomerFromFpInvoice(fpInvoice)

    const initialModelState = {
        ext_fp_invoice_id: subscription.ext_fp_invoice_id,
        ext_stripe_customer_id: subscription.ext_stripe_customer_id,
        ext_qbo_customer_id: subscription.ext_qbo_customer_id,
        start_date: subscription.start_date || new Date(),
        end_date: subscription.end_date,
        billing_period: subscription.billing_period || Constants.subscriptionBillingPeriodOptionsHash.monthly.value,

        // not stored in our DB, but necessary for Stripe subscription creation
        invoice_days_until_due: subscription.invoice_days_until_due || '30',
        description: subscription.description || '',
        invoice_template_memo: subscription.invoice_template_memo || '',
        invoice_template_footer: subscription.invoice_template_footer || '',

        invoiceLines: subscription.invoiceLines || [emptyInvoiceLine],

        fpCompanyId: fpInvoice?.invoicecompany?.id,
        showAddStripeCustomerModal: false,
        showAddQboCustomerModal: false,

        proposedStripeCustomer: _.clone(proposedCustomer),
        proposedQboCustomer: _.clone(proposedCustomer)
    };

    const fetchSupportingData = function () {
        let fpServiceOptions = [];
        let fpServiceTypeOptions = [];
        let stripeCustomerOptions = [];
        let stripeCustomerOptionsFlat = [];
        let qboCustomerOptions = [];
        let qboCustomerOptionsFlat = [];
        let subscriptionBillingPeriodOptions = [];

        return ApiUtility.getFpServicesList()
            .then(function (fpServices) {
                fpServiceOptions = (fpServices || []).map(function (fpService) {
                    return {
                        value: fpService['id'],
                        label: fpService['name'],
                        fpServiceTypeId: fpService.fp_service_type_id,
                        fpServiceTypeName: fpService.fp_service_type.name
                    }
                })
                return ApiUtility.getFpServiceTypesList()
            })
            .then(function (fpServiceTypesData) {
                fpServiceTypeOptions = SelectUtility.modelArrayToSelectOptions(fpServiceTypesData.fpServiceTypeList)
                return ApiUtility.getStripeCustomersList(fpInvoice?.invoicecompany?.id)
            })
            .then(function (stripeCustomers) {
                let stripeCustomerOptionsData = CustomerDataUtility.getStripeCustomerOptionsData(stripeCustomers)
                stripeCustomerOptions = stripeCustomerOptionsData.stripeCustomerOptions
                stripeCustomerOptionsFlat = stripeCustomerOptionsData.stripeCustomerOptionsFlat

                return ApiUtility.getQboCustomersList(fpInvoice?.invoicecompany?.id)
            })
            .then(function (qboCustomers) {
                let qboCustomerOptionsData = CustomerDataUtility.getQboCustomerOptionsData(qboCustomers)
                qboCustomerOptions = qboCustomerOptionsData.qboCustomerOptions
                qboCustomerOptionsFlat = qboCustomerOptionsData.qboCustomerOptionsFlat

                return ApiUtility.getSubscriptionBillingPeriods()
            })
            .then(function (subscriptionBillingPeriods) {
                subscriptionBillingPeriodOptions = SelectUtility.modelArrayToSelectOptions(
                    subscriptionBillingPeriods,
                    'ext_stripe_value',
                    'name'
                )
                return ApiUtility.getDefaultInvoiceSettingsUrl()
            })
            .then(function (urlResponse) {
                let stateChange = {
                    supportingData: {
                        invoiceDefaultsUrl: urlResponse.url,
                        fpServiceOptions: fpServiceOptions,
                        fpServiceTypeOptions: fpServiceTypeOptions,
                        qboInvoiceLineTypeOptions: [
                            {
                                label: Constants.qboInvoiceLineTypes.fpService,
                                value: Constants.qboInvoiceLineTypes.fpService
                            },
                            {
                                label: Constants.qboInvoiceLineTypes.custom,
                                value: Constants.qboInvoiceLineTypes.custom
                            },
                        ],
                        subscriptionBillingPeriodOptions: subscriptionBillingPeriodOptions,
                        stripeCustomerOptions: stripeCustomerOptions,
                        stripeCustomerOptionsFlat: stripeCustomerOptionsFlat,
                        qboCustomerOptions: qboCustomerOptions,
                        qboCustomerOptionsFlat: qboCustomerOptionsFlat
                    }
                }

                // auto-select Stripe customer if we find one that uses the FP invoice contact's email address
                if (formEngine.renderableData.proposedStripeCustomer?.email) {
                    let stripeCustomerOptionForEmail = _.find(stripeCustomerOptionsFlat, function (stripeCustomerOption) {
                        return (
                            formEngine.renderableData.proposedStripeCustomer?.email &&
                            stripeCustomerOption.email &&
                            formEngine.renderableData.proposedStripeCustomer?.email.toLowerCase() ===
                            stripeCustomerOption.email.toLowerCase()
                        )
                    })

                    if (stripeCustomerOptionForEmail) {
                        stateChange.ext_stripe_customer_id = stripeCustomerOptionForEmail.value;
                        stateChange.proposedStripeCustomer = {};
                    } else {
                        let stripeCustomerOptionForCompanyName = _.find(stripeCustomerOptionsFlat, function (stripeCustomerOption) {
                            return (
                                formEngine.renderableData.proposedStripeCustomer?.companyName &&
                                stripeCustomerOption.companyName &&
                                formEngine.renderableData.proposedStripeCustomer?.companyName.toLowerCase() ===
                                stripeCustomerOption.companyName.toLowerCase()
                            )
                        })

                        if (stripeCustomerOptionForCompanyName) {
                            stateChange.ext_stripe_customer_id = stripeCustomerOptionForCompanyName.value;
                            stateChange.proposedStripeCustomer = {};
                        }
                    }
                }

                // auto-select QBO customer if we find one that uses the FP invoice contact's email address
                if (formEngine.renderableData.proposedQboCustomer?.email) {
                    let qboCustomerOptionForEmail = _.find(qboCustomerOptionsFlat, function (qboCustomerOption) {
                        return (
                            formEngine.renderableData.proposedQboCustomer?.email &&
                            qboCustomerOption.email &&
                            formEngine.renderableData.proposedQboCustomer?.email.toLowerCase() ===
                            qboCustomerOption.email.toLowerCase()
                        )
                    })

                    if (qboCustomerOptionForEmail) {
                        stateChange.ext_qbo_customer_id = qboCustomerOptionForEmail.value;
                        stateChange.proposedQboCustomer = {};
                    } else {
                        let qboCustomerOptionForCompanyName = _.find(qboCustomerOptionsFlat, function (qboCustomerOption) {
                            return (
                                formEngine.renderableData.proposedQboCustomer?.companyName &&
                                qboCustomerOption.companyName &&
                                formEngine.renderableData.proposedQboCustomer?.companyName.toLowerCase() ===
                                qboCustomerOption.companyName.toLowerCase()
                            )
                        })

                        if (qboCustomerOptionForCompanyName) {
                            stateChange.ext_qbo_customer_id = qboCustomerOptionForCompanyName.value;
                            stateChange.proposedQboCustomer = {};
                        }
                    }
                }

                return Promise.resolve(stateChange);
            })
    }

    const formEngine = useModelFormEngine(
        initialModelState,
        subscription,
        fetchSupportingData,
        validateForm,
        formStateToSaveData,
        props.save
    );

    function validateForm(handleValidationResult) {
        return new Promise(function (resolve, reject) {
            let validationErrors = [];
            let invalidFields = [];

            Promise.resolve({})
                .then(function () {
                    if (!formEngine.renderableData.description) {
                        validationErrors.push(`Please enter a description.`);
                        invalidFields.push('description');
                    } else if (
                        formEngine.renderableData.description &&
                        formEngine.renderableData.description.length > Constants.maxSubscriptionDescriptionLength
                    ) {
                        validationErrors.push(`Description can't be longer than ${Constants.maxSubscriptionDescriptionLength} characters.`);
                        invalidFields.push('description');
                    }

                    if (!formEngine.renderableData.ext_stripe_customer_id) {
                        validationErrors.push('Please select a Stripe customer.');
                        invalidFields.push('ext_stripe_customer_id');
                    }

                    if (!formEngine.renderableData.ext_qbo_customer_id) {
                        validationErrors.push('Please select a QBO customer.');
                        invalidFields.push('ext_qbo_customer_id');
                    }

                    if (!formEngine.renderableData.start_date) {
                        validationErrors.push('Please select a start date.');
                        invalidFields.push('start_date');
                    }

                    if (!formEngine.renderableData.billing_period) {
                        validationErrors.push('Please select a billing period.');
                        invalidFields.push('billing_period');
                    }

                    if (
                        !formEngine.renderableData.invoice_days_until_due &&
                        '' + formEngine.renderableData.invoice_days_until_due !== '0'
                    ) {
                        validationErrors.push('Please enter a value for Days Until Due.');
                        invalidFields.push('invoice_days_until_due');
                    }

                    if (
                        !formEngine.renderableData.invoiceLines ||
                        formEngine.renderableData.invoiceLines.length === 0
                    ) {
                        validationErrors.push('Please add at least one line to the subscription invoice.');
                        invalidFields.push('invoiceLines');
                    } else {
                        for (let i = 0; i < formEngine.renderableData.invoiceLines.length; i++) {
                            let invoiceLine = formEngine.renderableData.invoiceLines[i];
                            if (!invoiceLine.invoice_line_type_id) {
                                validationErrors.push(`Please select a line type for invoice line ${i + 1}.`);
                                invalidFields.push(getInvoiceLineFieldId('invoiceLines', 'invoice_line_type_id', i));
                            } else {
                                if (!invoiceLine.name) {
                                    validationErrors.push(`Please enter an item name for invoice line ${i + 1}.`);
                                    invalidFields.push(getInvoiceLineFieldId('invoiceLines', 'name', i));
                                } else if (invoiceLine.name.indexOf(':') > -1) {
                                    validationErrors.push(`Invoice line labels can't contain colons (:). Please remove any colons from line ${i + 1}.`);
                                    invalidFields.push(getInvoiceLineFieldId('invoiceLines', 'name', i));
                                }

                                if (invoiceLine.invoice_line_type_id === Constants.qboInvoiceLineTypes.custom) {
                                    if (!invoiceLine.fp_service_type_id) {
                                        validationErrors.push(`Please select an FP service type for invoice line ${i + 1}.`);
                                        invalidFields.push(getInvoiceLineFieldId('invoiceLines', 'fp_service_type_id', i));
                                    }
                                } else {
                                    if (!invoiceLine.fp_service_id) {
                                        validationErrors.push(`Please select an FP service for invoice line ${i + 1}.`);
                                        invalidFields.push(getInvoiceLineFieldId('invoiceLines', 'fp_service_id', i));
                                    }
                                }
                            }
                        }
                    }

                    return handleValidationResult(validationErrors, invalidFields, resolve);
                });
        });
    }

    function formStateToSaveData(formStateToTransform) {
        let saveData = _.clone(formStateToTransform);
        saveData.supportingData = null;
        saveData.start_date = DateUtility.jsDateToUnixTimestamp(saveData.start_date)
        if (saveData.end_date) {
            saveData.end_date = DateUtility.jsDateToUnixTimestamp(saveData.end_date)
        }
        saveData.ext_stripe_customer_name = SelectUtility.selectOptionForId(
            saveData.ext_stripe_customer_id,
            formEngine.renderableData.supportingData.stripeCustomerOptionsFlat
        ).name
        return saveData;
    }

    function handleSelectChange(fieldName, option) {
        formEngine.updateAndRenderUnsavedData({[fieldName]: option.value});
    }

    function handleDateChange(fieldName, date) {
        formEngine.updateAndRenderUnsavedData({[fieldName]: date});
    }

    function handleInvoiceLineSelectChange(linesFieldName, fieldName, option, index) {
        let invoiceLinesUpdate = _.cloneDeep(formEngine.renderableData[linesFieldName]);
        invoiceLinesUpdate[index][fieldName] = option.value
        if (fieldName === 'invoice_line_type_id') {
            if (_.cloneDeep(formEngine.renderableData[linesFieldName])[index][fieldName] !== option.value) {
                invoiceLinesUpdate[index].fp_service_id = null
                invoiceLinesUpdate[index].fp_service_type_id = null
                invoiceLinesUpdate[index].fp_service_type_name = null
            }
        }
        if (fieldName === 'fp_service_id') {
            invoiceLinesUpdate[index].fp_service_type_id = option.fpServiceTypeId
            invoiceLinesUpdate[index].fp_service_type_name = option.fpServiceTypeName
            invoiceLinesUpdate[index].name = option.label
        }
        if (fieldName === 'fp_service_type_id') {
            invoiceLinesUpdate[index].fp_service_type_name = option.label
        }
        formEngine.updateAndRenderUnsavedData({[linesFieldName]: invoiceLinesUpdate});
    }

    function handleInvoiceLineTextFieldChange(linesFieldName, fieldName, event, index) {
        if (event && event.target) {
            let invoiceLinesUpdate = _.clone(formEngine.renderableData[linesFieldName]);
            invoiceLinesUpdate[index][fieldName] = event.target.value
            formEngine.updateAndRenderUnsavedData({[linesFieldName]: invoiceLinesUpdate});
        }
    }

    function forceInvoiceLineValueToFloat(linesFieldName, fieldName, index) {
        let invoiceLinesUpdate = _.clone(formEngine.renderableData[linesFieldName]);
        invoiceLinesUpdate[index][fieldName] = (parseFloat(invoiceLinesUpdate[index][fieldName]) || 0.0).toFixed(2);
        formEngine.updateAndRenderUnsavedData({[linesFieldName]: invoiceLinesUpdate});
    }

    function deleteInvoiceLineItem(linesFieldName, index) {
        let invoiceLinesUpdate = _.clone(formEngine.renderableData[linesFieldName]);
        invoiceLinesUpdate.splice(index, 1);
        formEngine.updateAndRenderUnsavedData({[linesFieldName]: invoiceLinesUpdate});
    }

    function addInvoiceLineItem(linesFieldName, emptyInvoiceLine) {
        let invoiceLinesUpdate = _.clone(formEngine.renderableData[linesFieldName]);
        invoiceLinesUpdate.push(_.clone(emptyInvoiceLine));
        formEngine.updateAndRenderUnsavedData({[linesFieldName]: invoiceLinesUpdate});
    }

    function onClickAddStripeCustomer() {
        formEngine.renderableData.updateAndRender({showAddStripeCustomerModal: true})
    }

    function closeAddStripeCustomerModal() {
        formEngine.renderableData.updateAndRender({showAddStripeCustomerModal: false})
    }

    function afterAddStripeCustomer(customerId) {
        closeAddStripeCustomerModal()
        formEngine.updateAndRenderUnsavedData({ext_stripe_customer_id: customerId})
        formEngine.refreshSupportingData()
    }

    function onClickAddQboCustomer() {
        formEngine.renderableData.updateAndRender({showAddQboCustomerModal: true})
    }

    function closeAddQboCustomerModal() {
        formEngine.renderableData.updateAndRender({showAddQboCustomerModal: false})
    }

    function afterAddQboCustomer(customerId) {
        closeAddQboCustomerModal()
        formEngine.updateAndRenderUnsavedData({ext_qbo_customer_id: customerId})
        formEngine.refreshSupportingData()
    }

    let invoiceLinesDisplay = []
    if (formEngine.renderableData.supportingData) {
        let supportingData = formEngine.renderableData.supportingData
        for (let index = 0; index < formEngine.renderableData.invoiceLines.length; index++) {
            let invoiceLine = formEngine.renderableData.invoiceLines[index]
            invoiceLinesDisplay.push(
                <InvoiceLineWithServicesFormRow
                    key={index}
                    index={index}
                    sequenceNumber={index + 1}
                    invoiceLine={invoiceLine}
                    invoiceLinesFieldId={'invoiceLines'}
                    qboInvoiceLineTypeOptions={supportingData.qboInvoiceLineTypeOptions}
                    fpServiceOptions={supportingData.fpServiceOptions}
                    fpServiceTypeOptions={supportingData.fpServiceTypeOptions}
                    handleInvoiceLineSelectChange={
                        (fieldName, option) => handleInvoiceLineSelectChange('invoiceLines', fieldName, option, index)
                    }
                    handleInvoiceLineTextFieldChange={
                        (fieldName, event) => handleInvoiceLineTextFieldChange('invoiceLines', fieldName, event, index)
                    }
                    forceInvoiceLineValueToFloat={
                        (fieldName) => forceInvoiceLineValueToFloat('invoiceLines', fieldName, index)
                    }
                    getFormFieldClasses={formEngine.getFormFieldClasses}
                    deleteInvoiceLineItem={() => deleteInvoiceLineItem('invoiceLines', index)}
                    allowEdits={true}
                />
            )
        }
    }

    let endDatePickerWrapperClasses = 'form-date-range-date-picker end-date-picker '
    if (!formEngine.renderableData.end_date) {
        endDatePickerWrapperClasses += 'hide-clear-button'
    }

    let invoiceDefaultsLinkDisplay = null
    if (formEngine.renderableData.supportingData) {
        invoiceDefaultsLinkDisplay = (
            <a
                href={formEngine.renderableData.supportingData.invoiceDefaultsUrl}
                className="external-text-link"
                target="_blank"
            >
                here
                <img
                    className="external-link-icon"
                    src="/static/images/open-external-link-moss-green.svg"
                />
            </a>
        )
    }

    let headerProps = {}
    if (props.fpInvoiceAsSubscriptionData) {
        headerProps.headerTextContentRenderer = () => (
            <div className="fp-invoice-subscription-header">
                <div className="fp-invoice-subscription-header-content">
                    <div className="fp-invoice-subscription-header-main">
                        {props.headerText}
                    </div>
                    <div className="fp-invoice-subscription-header-details">
                        {`(from FP invoice #${props.fpInvoiceAsSubscriptionData.ext_fp_invoice_number})`}
                    </div>
                </div>
            </div>
        )
    } else {
        headerProps.headerText = props.headerText
    }

    let total = 0;
    for (let d = 0; d < formEngine.renderableData.invoiceLines.length; d++) {
        total += parseFloat(formEngine.renderableData.invoiceLines[d].amount)
    }
    let totalDisplay = StringUtility.stringNumberToDisplayCurrency('' + total);
    let descriptionLength = ('' + formEngine.renderableData.description || '').length;
    let lengthIndicatorClass = `length-indicator ${descriptionLength > Constants.maxSubscriptionDescriptionLength ? 'invalid' : ''}`
    return (
        <Modal
            {...headerProps}
            onClickCloseOption={props.cancel}
            boxClass="subscription-modal-box"
        >
            <ConditionalRenderer if={formEngine.renderableData.showOverlayLoadingIndicator} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <ConditionalRenderer if={formEngine.renderableData.supportingData} renderer={() => (
                <Fragment>
                    <div className="common-form subscription-form">
                        <div className="common-form-body">
                            <div className="form-section">
                                <div className="form-section-label">Subscription details</div>
                                <div className="form-section-body">
                                    <div className="common-form-body-row">
                                        <div
                                            className={formEngine.getFormFieldClasses(
                                                "common-form-field subscription-description-field",
                                                "description"
                                            )}
                                        >
                                            <div className="common-form-field-label">
                                                Description
                                            </div>
                                            <div className="common-form-field-input-container">
                                                <div className="common-form-field-input-container-content">
                                                    <textarea
                                                        id="description"
                                                        className="common-form-textarea"
                                                        value={formEngine.renderableData.description}
                                                        onChange={(event) => formEngine.handleTextFieldChange(
                                                            "description",
                                                            event
                                                        )}
                                                        maxLength={Constants.maxSubscriptionDescriptionLength}
                                                    />
                                                    <div className={lengthIndicatorClass}>
                                                        {`${descriptionLength} / ${Constants.maxSubscriptionDescriptionLength}`}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="common-form-body-row">
                                        <div
                                            className={formEngine.getFormFieldClasses(
                                                "common-form-field",
                                                "ext_stripe_customer_id"
                                            )}
                                        >
                                            <div className="common-form-field-label">
                                                Stripe Customer
                                            </div>
                                            <div className="common-form-field-input-container">
                                                <Select
                                                    className="common-form-select stripe-customer-select"
                                                    classNamePrefix="common-form-select"
                                                    value={SelectUtility.selectOptionForId(
                                                        formEngine.renderableData.ext_stripe_customer_id,
                                                        formEngine.renderableData.supportingData.stripeCustomerOptionsFlat
                                                    )}
                                                    onChange={(option) => handleSelectChange(
                                                        'ext_stripe_customer_id',
                                                        option
                                                    )}
                                                    options={formEngine.renderableData.supportingData.stripeCustomerOptions}
                                                />
                                            </div>
                                            <div className="common-form-select-add-option-container">
                                                <PillButton
                                                    onClick={onClickAddStripeCustomer}
                                                    leftIconSrc={"/static/images/plus-textcolor.svg"}
                                                    containerClasses="add-button-container"
                                                    buttonClasses="add-button add-stripe-customer-button"
                                                    title="Add Stripe Customer"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="common-form-body-row">
                                        <div
                                            className={formEngine.getFormFieldClasses("common-form-field", "ext_qbo_customer_id")}>
                                            <div className="common-form-field-label">
                                                QBO Customer
                                            </div>
                                            <div className="common-form-field-input-container">
                                                <Select
                                                    className="common-form-select qbo-customer-select"
                                                    classNamePrefix="common-form-select"
                                                    value={SelectUtility.selectOptionForId(
                                                        formEngine.renderableData.ext_qbo_customer_id,
                                                        formEngine.renderableData.supportingData.qboCustomerOptionsFlat
                                                    )}
                                                    onChange={(option) => handleSelectChange(
                                                        'ext_qbo_customer_id',
                                                        option
                                                    )}
                                                    options={formEngine.renderableData.supportingData.qboCustomerOptions}
                                                />
                                            </div>
                                            <div className="common-form-select-add-option-container">
                                                <PillButton
                                                    onClick={onClickAddQboCustomer}
                                                    leftIconSrc={"/static/images/plus-textcolor.svg"}
                                                    containerClasses="add-button-container"
                                                    buttonClasses="add-button add-qbo-customer-button"
                                                    title="Add QBO Customer"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="common-form-body-row">
                                        <div
                                            className={formEngine.getFormFieldClasses(
                                                "common-form-field",
                                                ["start_date", "end_date"]
                                            )}
                                        >
                                            <div className="common-form-field-label">
                                                Duration
                                            </div>
                                            <div className="common-form-field-input-container">
                                                <div className="form-date-range-container">
                                                    <div
                                                        className={formEngine.getFormFieldClasses(
                                                            "form-date-range-date-picker start-date-picker",
                                                            "start_date"
                                                        )}
                                                    >
                                                        <DatePicker
                                                            selected={formEngine.renderableData.start_date}
                                                            onChange={(date) => handleDateChange('start_date', date)}
                                                            minDate={DateUtility.currentJsDate()}
                                                            selectsStart
                                                            startDate={formEngine.renderableData.start_date}
                                                            endDate={formEngine.renderableData.end_date}
                                                        />
                                                    </div>
                                                    <div className="form-date-range-to">
                                                        to
                                                    </div>
                                                    <div className={endDatePickerWrapperClasses}>
                                                        <DatePicker
                                                            selected={formEngine.renderableData.end_date}
                                                            onChange={(date) => handleDateChange('end_date', date)}
                                                            placeholderText="Forever"
                                                            isClearable={true}
                                                            selectsEnd
                                                            startDate={formEngine.renderableData.start_date}
                                                            endDate={formEngine.renderableData.end_date}
                                                            minDate={formEngine.renderableData.start_date}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="common-form-body-row">
                                        <div
                                            className={formEngine.getFormFieldClasses("common-form-field", "billing_period")}>
                                            <div className="common-form-field-label">
                                                Billing Period
                                            </div>
                                            <div className="common-form-field-input-container">
                                                <Select
                                                    className="common-form-select billing-period-select"
                                                    classNamePrefix="common-form-select"
                                                    value={SelectUtility.selectOptionForId(
                                                        formEngine.renderableData.billing_period,
                                                        formEngine.renderableData.supportingData.subscriptionBillingPeriodOptions
                                                    )}
                                                    onChange={(option) => handleSelectChange(
                                                        'billing_period',
                                                        option
                                                    )}
                                                    options={formEngine.renderableData.supportingData.subscriptionBillingPeriodOptions}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-section">
                                <div className="form-section-label">Subscription invoice details</div>
                                <div className="form-section-body">
                                    <div className="common-form-list">
                                        <div className="common-form-list-header">
                                            <div className="common-form-list-header-content">
                                                <div className="common-form-list-row-cell number">#</div>
                                                <div className="common-form-list-row-cell type">Line Type</div>
                                                <div className="common-form-list-row-cell fp-service">FP Service</div>
                                                <div className="common-form-list-row-cell name">
                                                    Label (shown to customer)
                                                </div>
                                                <div className="common-form-list-row-cell fp-service-type">
                                                    FP Service Type
                                                </div>
                                                <div className="common-form-list-row-cell amount">Amount</div>
                                                <div className="common-form-list-row-cell delete-button"></div>
                                            </div>
                                        </div>
                                        <div
                                            className={formEngine.getFormFieldClasses(
                                                "common-form-list-body",
                                                "invoiceLines"
                                            )}
                                        >
                                            {invoiceLinesDisplay}
                                            <div className="subscription-invoice-total">
                                                <div className="subscription-invoice-total-content">
                                                    <div className="subscription-invoice-total-label">
                                                        TOTAL:
                                                    </div>
                                                    <div className="subscription-invoice-total-value">
                                                        {totalDisplay}
                                                    </div>
                                                </div>
                                            </div>
                                            <PillButton
                                                onClick={() => addInvoiceLineItem('invoiceLines', emptyInvoiceLine)}
                                                leftIconSrc={"/static/images/plus-textcolor.svg"}
                                                containerClasses="add-button-container add-invoice-line-button-container"
                                                buttonClasses="add-button add-invoice-line-button"
                                                buttonText={"ADD LINE"}
                                            />
                                        </div>
                                    </div>

                                    <div className="common-form-body-row">
                                        <div
                                            className={formEngine.getFormFieldClasses(
                                                "common-form-field",
                                                "invoice_days_until_due"
                                            )}
                                        >
                                            <div className="common-form-field-label">
                                                Days Until Due
                                            </div>
                                            <div className="common-form-field-input-container">
                                                <input
                                                    id="invoice_days_until_due"
                                                    type="text"
                                                    className="common-form-input"
                                                    value={formEngine.renderableData.invoice_days_until_due}
                                                    onChange={(event) => formEngine.handleTextFieldChange(
                                                        "invoice_days_until_due", event
                                                    )}
                                                    onBlur={() => formEngine.forceValueToNumeric('invoice_days_until_due')}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="common-form-body-row">
                                        <div className="invoice-defaults-blurb">
                                            See invoice default memo and footer settings {invoiceDefaultsLinkDisplay}.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="common-form-body-row subscription-form-options-row">
                                <div className="subscription-form-submit-description">
                                    <div>
                                        {"Submitting this subscription will create it in Stripe and send an invoice via Stripe to the customer."}
                                    </div>
                                    <div>
                                        {"Once the Stripe invoice exists, you'll need to sync to create the invoice in QBO."}
                                    </div>
                                </div>
                                <div className="subscription-form-submit-description">
                                    <div>
                                        {"Please don't change the above invoice line products in Stripe after creating this."}
                                    </div>
                                    <div>
                                        {"Doing so can break their association to the correct QBO accounts and prevent future syncs from working."}
                                    </div>
                                </div>
                                <div className="common-form-options">
                                    <PillButton
                                        onClick={formEngine.onClickSave}
                                        containerClasses="common-form-button-container"
                                        buttonClasses="common-form-button save-button"
                                        buttonText={"SUBMIT"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {(() => {
                        if (formEngine.renderableData.showAddStripeCustomerModal) {
                            return (
                                <CreateStripeCustomer
                                    customer={formEngine.renderableData.proposedStripeCustomer}
                                    cancel={closeAddStripeCustomerModal}
                                    afterSuccessfulSave={afterAddStripeCustomer}
                                />
                            )
                        } else if (formEngine.renderableData.showAddQboCustomerModal) {
                            return (
                                <CreateQboCustomer
                                    customer={formEngine.renderableData.proposedQboCustomer}
                                    cancel={closeAddQboCustomerModal}
                                    afterSuccessfulSave={afterAddQboCustomer}
                                />
                            )
                        }
                    })()}
                </Fragment>
            )}/>
        </Modal>
    );
};
